export function pluralize(quantity, singular, plural) {
  return (quantity === 1) ? singular : plural;
}

export function pluralizeWithPrefix(quantity, singular, plural, unlessSingular=false) {
  if (quantity === 1) {
    if (unlessSingular) return singular;
    return `${quantity} ${singular}`;
  }
  return `${quantity} ${plural}`;
}

export function formatInvoiceNr(nr) {
  if (nr === null) return "";
  if (nr === "") return "";
  return nr.slice(0,8) + "-" + nr.slice(8);
}

const currencyToSymbol = (currency) => {
  switch (currency) {
    case "EUR":
      return "€";
    case "CAD":
    case "USD":
      return "$";
    case "GBP":
      return "£";
    case "CHF":
      return "Fr.";
    default:
      return currency;
  }
}

// E.g. in normal mode: EUR 120.00
// In tight mode, if there is no decimal it becomes $120
// In finance, currency is displayed before the amount, but sometimes we want it second.
export function currencyFormat(num, currency, decimals = 2, modeTight = false, currencyFirst = true) {
  if (isNaN(num) || num === null) return null;

  if (modeTight && Math.round(num) === num) {
    decimals = 0;
  }
  const formattedValue = num.toFixed(decimals).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

  if (modeTight) {
    // todo i18n change position depending on language/country?
    return currencyToSymbol(currency) + formattedValue;
  }
  
  return currencyFirst
    ? currency + " " + formattedValue
    : formattedValue + " " + currency;
}

// e.g. "processing_payment" => "Processing Payment"
export function formatStatus(str) {
  return (str || "").replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase());
}
